import 'telia-front-react/public/css/styles.css';
import './failures-map.scss';
import './tabs.scss';

import('bootstrap');
